import Utils from "./Common.util";

class ValidationUtils {
    static isstringvalid(value = '') {
        return ValidationUtils.required(value) && String(value).length > 0;
    }

    static required(value) {
        if (value != null && value.hasOwnProperty('length') && value.length === 0) {
            return false;
        }
        return !(value == null || value === '' || value == undefined);
    }

    static isemail(value = '') {
        const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return !!value.match(pattern);
    }

    static isnumber(value) {
        return typeof value === 'number' || (ValidationUtils.isstringvalid(value) && !isNaN(value));
    }

    static isnumeric(value) {
        return typeof value === 'number' || (ValidationUtils.isstringvalid(value) && !isNaN(value));
    }

    static minlength(value, length) {
        return ValidationUtils.isstringvalid(value) && value.trim().length >= Number(length);
    }

    static maxlength(value, length) {
        return ValidationUtils.isstringvalid(value) && value.trim().length <= Number(length);
    }

    static min(value, min = 0) {
        return ValidationUtils.isnumber(value) && value >= Number(min);
    }

    static max(value, max = 99999999) {
        return ValidationUtils.isnumber(value) && value <= Number(max);
    }

    static inarray(value, array = []) {
        return true;
    }

    static isarray(value, array = []) {
        return Array.isArray(value);
    }

    static regex(value, format) {
        return true;
    }

    static datetime(date = '', format = 'm/d/Y H:i') {
        return true;
    }

    static date(date, format = 'm/d/Y') {
        return true;
    }

    static time(date, format = 'H:i') {
        return true;
    }

    static istel(value = '') {
        // const pattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/
        const pattern1 = /^[\+]?[(]?[0-9]{3}[)] ?\d{6,16}$/im;
        const pattern2 = /^[\+]?[(]?[0-9]{2}[)] ?\d{6,16}$/im
        return value.match(pattern1) || value.match(pattern2);
        // return true  
    }

    static hasdupes(value = '') {
        return true
    }

    static uploadfilemax(files = [], max = 1) {
        return files.length <= Number(max);
    }

    static uploadfilemin(files = [], min = 1) {
        return files.length >= Number(min);
    }

    static uploadfilemimetype(files = [], extensions = '') {
        const spitExts = extensions.toLowerCase().split(',');
        for (let i = 0; i < spitExts.length; i++) {
            const ext = spitExts[i].trim();
            const isNotContainEx = files.find(item => item.toLowerCase().indexOf(ext) > -1) === null;
            if (isNotContainEx) {
                return false;
            }
        }
        return true;
    }

    /**
     * 
     * @param {IFile} file 
     * @param {number} size 
     * @returns 
     */
    static uploadfilesize(file, size = 5 * 1024 * 1024) {
        return file.size <= size;
    }

    static maxword(value, length) {
        return ValidationUtils.isstringvalid(value) && Utils.WordCounter(value) <= Number(length);
    }

    static minword(value, length) {
        return ValidationUtils.isstringvalid(value) && Utils.WordCounter(value) >= Number(length);
    }

    static notrequired() {
        return true;
    }

}

export default ValidationUtils;